import { useOutletContext } from "react-router-dom";
// DashboardOverview removed - Wallet is now the master dashboard page
// DashboardAddresses and DashboardBankAccounts removed - functionality moved to Wallet and Send pages
import { DashboardCalculator } from "@/components/dashboard/DashboardCalculator";
import { DashboardContextType } from "@/components/dashboard/DashboardContext";
import { DashboardHelp } from "@/components/dashboard/DashboardHelp";
import { DashboardProfile } from "@/components/dashboard/DashboardProfile";
import { DashboardSettings } from "@/components/dashboard/DashboardSettings";
import { DashboardTelegramCard } from "@/components/dashboard/DashboardTelegramCard";
import WalletPage from "@/components/wallet/WalletPage";
// TransactionHistoryPage removed - Transactions are now part of Wallet (Revolut-style consolidation)
import WalletDetailPage from "@/pages/dashboard/WalletDetailPage";
import { TransactionDetailPage } from "@/pages/TransactionDetailPage";
import { VirtualAccountDetailPage } from "@/pages/VirtualAccountDetailPage";
// ReceivePage DEPRECATED - Wallet-Centric UX (all receive functionality is now in Wallet)
import SendPage from "@/pages/dashboard/SendPage";
import { useNavigate, useParams } from "react-router-dom";

// DashboardOverviewRoute removed - Wallet is now the master dashboard page
// /dashboard redirects to /dashboard/wallet via DashboardIndex

// DashboardAddressesRoute removed - addresses are now on ReceivePage

// Wrapper for DashboardProfile
export function DashboardProfileRoute() {
  const context = useOutletContext<DashboardContextType>();
  const navigate = useNavigate();
  return (
    <DashboardProfile
      bridgeCustomerId={context.bridgeCustomerId}
      kycStatus={context.kycStatus}
      tosStatus={context.tosStatus}
      kycRealtime={context.kycRealtime}
      statusRefreshKey={context.statusRefreshKey}
      onStatusRefresh={context.onStatusRefresh}
      hasBankAccount={context.payoutRoutes.length > 0}
      hasAddress={context.addresses.length > 0}
      hasTransactions={context.transactions.length > 0}
      canCreateAddress={context.canCreateAddress}
      onAddBankAccount={context.onAddBankAccount}
      onAddAddress={context.onAddAddress}
      onViewTransactions={() => navigate('/dashboard/wallet')}
      onOpenSettings={() => navigate('/dashboard/settings')}
    />
  );
}

// DashboardBankAccountsRoute removed - bank accounts are now on SendPage

// DEPRECATED: ReceivePageRoute removed - Wallet-Centric UX (all functionality moved to Wallet)
// Receive page now redirects to /dashboard/wallet in routeTree.tsx

export function SendPageRoute() {
  return <SendPage />;
}

// Export WalletPage as WalletOverview for route compatibility
export {
  DashboardCalculator,
  DashboardHelp,
  DashboardSettings,
  // TransactionHistoryPage removed - now part of Wallet (Revolut-style consolidation)
  // VirtualAccountsPage removed - now part of ReceivePage (Revolut-style consolidation)
  WalletPage as WalletOverview
};

export function DashboardTelegramRoute() {
  return (
    <div className="space-y-6">
      <DashboardTelegramCard
        onOpenSettings={() => window.location.href = '/telegram'}
      />
    </div>
  );
}

export function TransactionDetailRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  if (!id) return null;

  // Smart back navigation: go back in history, fallback to activity page
  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/dashboard/activity');
    }
  };

  return (
    <TransactionDetailPage
      id={id}
      onBack={handleBack}
    />
  );
}

// Wallet Detail Route
export function WalletDetailRoute() {
  return <WalletDetailPage />;
}

export function VirtualAccountDetailRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  if (!id) return null;
  return (
    <VirtualAccountDetailPage
      id={id}
      onBack={() => navigate('/dashboard/receive')}
    />
  );
}
